import { __RouterContext } from 'react-router';
import { useContext } from 'react';

export default function useHistory() {
    const context = useContext(__RouterContext);
    return context.history;
}
